
//Xmas babay slider
      $(document).ready(function(){
        $('.xmas-inner').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
        dots:false,
        autoplay: true,
  		autoplaySpeed: 2000
        });
      });